import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { combineLatest, Observable } from 'rxjs';
import { faFileAlt, faCheck } from '@fortawesome/free-solid-svg-icons';
import { IDocumentResponse } from 'src/app/models/document.model';
import { IFormFieldsRequest } from 'src/app/models/form.interface';
import { ModulesService } from 'src/app/services/modules.service';
import { TemplatesService } from 'src/app/services/templates.service';

@Component({
  selector: 'app-standalone-docs-v2',
  templateUrl: './standalone-docs.component.html',
  styleUrls: ['./standalone-docs.component.sass']
})
export class StandaloneDocsV2Component implements OnInit {
  // Icons
  faFileAlt = faFileAlt;
  faCheck = faCheck;

  files: Array<IDocumentResponse> = [];
  loading = false;
  selectedFiles: Array<string> = [];
  
  patientId: string | null = '';
  patientEmail: string | null = '';
  patientName: string | null = '';
  isModelPatient: boolean = false;
  standalone: boolean = false;

  viewModules$: Observable<{ moduleName: string; moduleNamePascalCase: string; moduleNameInSingular: string; }>;

  constructor(
    private router: Router,
    private templatesService: TemplatesService,
    private route: ActivatedRoute,
    public modulesService: ModulesService
  ) {
    this.viewModules$ = combineLatest({
      moduleName: this.modulesService.moduleName$,
      moduleNamePascalCase: this.modulesService.moduleNamePascalCase$,
      moduleNameInSingular: this.modulesService.moduleNameInSingular$
    });
  }

  ngOnInit(): void {
    this.loading = true;

    this.patientId = this.route?.snapshot?.queryParams['patientId'];
    this.patientEmail = this.route?.snapshot?.queryParams['patientEmail'];
    this.patientName = this.route?.snapshot?.queryParams['patientName'];
    
    const qpIsModel = this.route?.snapshot?.queryParams['isModelPatient'];
    this.isModelPatient = qpIsModel === 'true' || qpIsModel === true;
    
    this.standalone = this.route?.snapshot?.queryParams['standalone'] === 'true' || 
                      this.route?.snapshot?.queryParams['standalone'] === true;

    this.loadDocuments();
  }

  loadDocuments(): void {
    const tags = this.standalone ? ['DOCUMENTO_AVULSO'] : [];
    
    // Clínica sem anamnese contratada: usar flag de paciente modelo na listagem
    const anamneseAuthType = localStorage.getItem('anamneseAuthType') 
      ? atob(localStorage.getItem('anamneseAuthType') as string) 
      : 'NOT_CONTRACTED';
    const clinicHasAnamnese = ['VIRTUAL', 'BOTH'].includes(anamneseAuthType);
    const isModelForDocs = !clinicHasAnamnese ? this.isModelPatient : false;

    this.templatesService.list(tags, this.modulesService.moduleId, isModelForDocs)
      .then(response => {
        this.files = response;
      })
      .finally(() => {
        this.loading = false;
      });
  }

  toggleFileSelection(id: string): void {
    const index = this.selectedFiles.findIndex(selectedId => selectedId === id);
    if (index > -1) {
      this.selectedFiles.splice(index, 1);
    } else {
      this.selectedFiles.push(id);
    }
  }

  isSelected(id: string): boolean {
    return this.selectedFiles.includes(id);
  }

  selectAll(): void {
    if (this.selectedFiles.length === this.files.length) {
      this.selectedFiles = [];
    } else {
      this.selectedFiles = this.files.map(f => f.id);
    }
  }

  onBackToPatient(): void {
    if (this.patientId) {
      const moduleName = (this.modulesService.moduleName || '').toString().toUpperCase();
      if (moduleName === 'PACIENTES') {
        this.router.navigate(['main', 'v2', 'patients', this.patientId, 'edit']);
      } else {
        this.router.navigate(['main', 'v2', 'modules', moduleName.toLowerCase(), this.patientId, 'edit']);
      }
    } else {
      this.router.navigate(['main', 'v2', 'patients']);
    }
  }

  onSubmit(): void {
    if (this.selectedFiles.length < 1) {
      return;
    }
    
    const request: IFormFieldsRequest = {
      document_ids: this.selectedFiles
    };
    
    this.router.navigate(['main', 'v2', 'patients', 'document-form'], { 
      queryParams: { 
        request: btoa(JSON.stringify(request)), 
        patientId: this.patientId 
      } 
    });
  }
}
